import { Button, Grid, GridColumn, GridRow } from '@bp/ui-components';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthClaims } from '../../hooks/useAuthClaims';

export const AccountForm = () => {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();

  const handlePasswordChangeRequest = useCallback(() => {
    window.location.href = `${import.meta.env.VITE_APP_AUTH_SERVER_URI}/account/password?return_to=${encodeURIComponent(window.location.href)}`;
  }, []);

  return (
    <Grid>
      <GridRow>
        <GridColumn width={2}>
          <Button onClick={handlePasswordChangeRequest}>{t('profiles.changePassword')}</Button>
        </GridColumn>
        <GridColumn width={3}>
          <div>{t('auth.loginEmail', { email: pimAuthClaims.getLoginEmail() })}</div>
          <div className={'hint'}>{t('auth.changeLoginEmailHint')}</div>
        </GridColumn>
      </GridRow>
    </Grid>
  );
};
